import {
  projectName,
  projectNames,
} from '@/shared/constants/system';

export const landerBotErrorSign = 'заявка не отправлена';
export const landerSuccessSign = 'send-success';
export const landerBotErrorMessage =
  'Отправка заявки заблокирована анти-спам системой. Пожалуйста попробуйте снова через 5 минут';
export const landerMessageDuration = 6000;

export const LANDER_VERSION_BY_PROJECT: Record<string, string> = {
  [projectNames.MTI]: 'moicapital',
};

export const landerVersion = LANDER_VERSION_BY_PROJECT[projectName as string] ?? '';
